import { getErrorMessage } from '../../../lib/utils';

export default function (app) {
  return {
    state: {
      users: [],
    },
    getters: {

    },
    actions: {
      async createUser({ commit, dispatch, }, { username, password, }) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const result = await app.service('users').create({ username, password, });

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async removeUser({ commit, dispatch, }, id) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const result = await app.service('users').remove(id);

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async updateUser({ commit, state, dispatch, }, id) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const user = state.users.filter(({ id: userId, }) => userId === id).pop();
          if (!user) {
            return;
          }

          const result = await app.service('users').patch(id, user);

          commit('setUserEditable', { id, editable: false, });

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async listUsers({ commit, dispatch, }, params = {}) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const result = await app.service('users').find(params);
          commit('setUsers', result.data);

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },
    },
    mutations: {
      setUsers: (state, users) => state.users = users,
      setUserEditable: (state, { id: userId, editable, }) => state.users = state.users.map(user => ({
        ...user,
        editable: editable && user.id === userId,
      })),
      setUserProperty: (state, { id, property, value, }) => state.users.forEach(user => {
        if (user.id === id) {
          user[property] = value;
        }
      }),
    },
  };
}
